const selectReleaseNotes = (state) => state.releaseNotes;
export const selectReleaseNotesData = (state) => selectReleaseNotes(state).data;
export const selectReleaseNotesTotal = (state) => selectReleaseNotes(state).total;
export const selectReleaseNote = (state) => state.releaseNote;
export const selectLatestReleaseNote = (state) => state.latestReleaseNote;
